import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var SocialAccountBase = t.type({
  id: t.string,
  authUrl: t.string,
  connected: t["boolean"],
  visible: t["boolean"]
});
var Facebook = t.intersection([t.type({
  __typename: t.literal('Facebook'),
  profileUrl: nullable(t.string)
}), SocialAccountBase]);
var Linkedin = t.intersection([t.type({
  __typename: t.literal('Linkedin'),
  profileUrl: nullable(t.string),
  expiresAt: nullable(t.string)
}), SocialAccountBase]);
var Twitter = t.intersection([t.type({
  __typename: t.literal('Twitter'),
  profileUrl: nullable(t.string)
}), SocialAccountBase]);
var Apple = t.intersection([t.type({
  __typename: t.literal('Apple')
}), SocialAccountBase]);
var OAuth2 = t.intersection([t.type({
  __typename: t.literal('OAuth2'),
  name: t.string
}), SocialAccountBase]);
var Google = t.intersection([t.type({
  __typename: t.literal('Google')
}), SocialAccountBase]);
export var SocialAccount = t.union([Facebook, Linkedin, Twitter, Apple, OAuth2, Google], 'SocialAccount');
export var VisibleSocialAccount = t.union([Facebook, Linkedin, Twitter, Apple, OAuth2], 'VisibleSocialAccount');
export var RevokeSocialAuthInput = t.type({
  input: t.type({
    id: t.string
  })
});
export var RevokeSocialAuthOutput = t.type({
  revokeSocialAuthentication: t.type({
    __typename: t.literal('RevokeSocialAuthenticationResult'),
    socialAccount: t.intersection([t.type({
      id: t.string,
      connected: t["boolean"]
    }), t.partial({
      profileUrl: nullable(t.string),
      expiresAt: nullable(t.string)
    })])
  })
});